import { NgModule } from '@angular/core';

// import { EnvironmentItemComponent } from '@app/authorized/projectWizard/environment-item/environment-item.component';
import {AssignSchemasComponent} from './assignSchemas'
import {EnvironmentTypeRotatorModule} from './environmentTypeRotator/environmentTypeRotator.module'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms';
import { EnvironmentTypeModule } from '@app/authorized/project/pipeline/environments-ang7/environmentType.module';

@NgModule({
    imports: [ FormsModule,EnvironmentTypeRotatorModule,CommonModule,EnvironmentTypeModule],
    declarations: [
        // EnvironmentItemComponent,
        AssignSchemasComponent,
    ],
    entryComponents: [
        AssignSchemasComponent,
    ],
    exports: [
        AssignSchemasComponent
        ]
})
export class AssignSchemasModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/assignSchemas-ang7/assignSchemas.module.ts